import React from "react"
import PropTypes from "prop-types"
import RegistrationsPropTypes from "utils/prop_types"
import accounting from "accounting"
import { centsToUnformatted } from "utils/money"

class PaymentAmountTextInput extends React.Component {
  static propTypes = {
    amountCents: PropTypes.number.isRequired,
    currency: RegistrationsPropTypes.Currency.isRequired,
    onChange: PropTypes.func.isRequired
  }

  render() {
    return (
      <div>
        <div className="d-f ai-c" css={{ width: 120 }}>
          <label className="pr-4p">{this.props.currency.symbol}</label>
          <input
            className="small-input"
            defaultValue={this.getUnformattedAmount()}
            onChange={this.handleChange}
            type="text"
            css={{
              marginTop: "-8px !important",
              marginBottom: "-8px !important"
            }}
          />
        </div>
      </div>
    )
  }

  getUnformattedAmount = () => {
    const { amountCents, currency } = this.props
    return centsToUnformatted(amountCents, currency)
  }

  handleChange = event => {
    const { currency, onChange } = this.props
    const decimal = accounting.unformat(event.target.value)
    const decimalAmount = decimal * currency.subunitToUnit
    onChange(decimalAmount)
  }
}

export default PaymentAmountTextInput
